import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { LoadingController } from "@ionic/angular"; /* NEED FIX */

import { console } from "#/log";

/** aka HtmlIonLoadingElement */
type Loading = Awaited<ReturnType<LoadingController["create"]>>;

@Injectable()
export class LoadingService {
  private loading: Loading | undefined;
  private currentlyLoading: BehaviorSubject<boolean> = new BehaviorSubject(
    false,
  );

  constructor(private loadCtrl: LoadingController) {}

  get loadingStatus() {
    return this.currentlyLoading.asObservable();
  }

  /**
   * Shows spinner prompt with arbitrary message
   */
  async showSpinner(message?: string): Promise<void> {
    try {
      this.loading = await this.loadCtrl.create({
        message: message ?? "Please Wait",
      });
      await this.loading.present();
      this.currentlyLoading.next(true);
    } catch (error) {
      return console.debug(
        "LoadingService: showSpinner(): spinner not presented:",
        error,
      );
    }
  }

  /**
   * Dismiss the spinner
   */
  async dismissSpinner(): Promise<any> {
    if (this.loading) {
      try {
        await this.loading.dismiss();
        this.loading = undefined;
        this.currentlyLoading.next(false);
      } catch (error) {
        return console.debug(
          "LoadingService: dismissSpinner(): spinner not dismissed:",
          error,
        );
      }
    }
  }
}
